import request from "@/utils/request";

// 查询用户证书
export const  userCerts =(query) =>{
    return request({
        url: "/businessservice/cert/userCerts",
        method:"get",
        params: query
    })
}

// 删除用户证书
export const  certDelete =(query) =>{
    return request({
        url: "/businessservice/cert/delete",
        method:"get",
        params: query
    })
}